module.exports = __webpack_public_path__ + "media/images/icons/talk-d92d76dabdcd73d33d3bb65fd6213a70.svg";